import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  teamNotification: [{}],
  authorizedTeamWithRbac: [{}],
  adminTeamNotification: [],
  updateNotificationForCompany: [],
  selectedCustomerData: {},
  selectedTeamData: {},
  selectedTeamCustomerData: {},
  adminTeamNotificationSettings: {},
  teamNotificationSettings: {},
  adminSelectedTeam: '',
  isLoadingUserNotificationForCustomer: false,
  userNotificationForCustomer: {},
  isLoading: true,
  error: null,
};

const companyNotificationSlice = createSlice({
  name: 'companyNotification',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setTeamNotification: (state, action) => {
      state.teamNotification = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setUpdateNotificationForCompany: (state, action) => {
      state.updateNotificationForCompany = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setAdminTeamNotification: (state, action) => {
      state.adminTeamNotification = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setAuthorizedTeamWithRbac: (state, action) => {
      state.authorizedTeamWithRbac = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setSelectedAdminTeam: (state, action) => {
      state.adminSelectedTeam = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomerData = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setSelectedTeam: (state, action) => {
      state.selectedTeamData = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setSelectedTeamCustomer: (state, action) => {
      state.selectedTeamCustomerData = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setAdminTeamNotificationSettings: (state, action) => {
      state.adminTeamNotificationSettings = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setTeamNotificationSettings: (state, action) => {
      state.teamNotificationSettings = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    startIsLoadingUserNotificationForCustomer: (state) => {
      state.isLoadingUserNotificationForCustomer = true;
    },
    stopIsLoadingUserNotificationForCustomer: (state) => {
      state.isLoadingUserNotificationForCustomer = false;
    },

    setUserNotificationForCustomer: (state, action) => {
      state.userNotificationForCustomer = action.payload;
      state.error = null;
      state.isLoading = false;
      state.isLoadingUserNotificationForCustomer = false;
    },
    setResetCompanyNotification: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAuthorizedTeamWithRbac,
  setTeamNotification,
  setResetCompanyNotification,
  setUpdateNotificationForCompany,
  setAdminTeamNotification,
  setSelectedCustomer,
  setSelectedTeam,
  setSelectedAdminTeam,
  setSelectedTeamCustomer,
  setAdminTeamNotificationSettings,
  setTeamNotificationSettings,
  setUserNotificationForCustomer,
  startIsLoadingUserNotificationForCustomer,
  stopIsLoadingUserNotificationForCustomer,
} = companyNotificationSlice.actions;

export default companyNotificationSlice.reducer;
